import { useTheme } from '@mui/material/styles';
import React from 'react';

import { useIsMobile } from '@hooks/useIsMobile';

/**
 * Use to add a rounded lip below page titles with a blue background
 */
const HeaderArc: React.FC = () => {
  const theme = useTheme();
  const isMobile = useIsMobile('sm');
  const [vbHeight, arcHeight] = React.useMemo(() => {
    if (isMobile) {
      return [10, 15];
    }
    return [3, 4];
  }, [isMobile]);

  const gradientColors = [
    theme.palette.primary.light,
    theme.palette.primary.dark,
  ];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 100 ${vbHeight}`}
      preserveAspectRatio="none"
      filter="drop-shadow(rgba(26, 26, 26, 0.24) 0px 3px 2px)"
    >
      <defs>
        <linearGradient id="header-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor={gradientColors[0]} stopOpacity="1" />
          <stop offset="100%" stopColor={gradientColors[1]} stopOpacity="1" />
        </linearGradient>
      </defs>
      <path
        d={`M0,0 L0,1 Q40,${arcHeight} 101,1 L101,0 Z`}
        fill="url(#header-gradient)"
      />
    </svg>
  );
};

export default HeaderArc;
